import React, { useEffect, useState } from 'react'
import { AppBar, Grid, Tab, Tabs, useMediaQuery } from '@material-ui/core'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import EurestoAction from './EurestoAction'
import Select from 'Components/Select'
import Modal from 'Components/Modal'

export default React.memo(props => {

  const handleAction = async (act) => {
    if (props.btns && props.btns[act]) {
      props.onChangeAction(act, {
        matchesXs: matchesXs,
        matchesSm: matchesSm,
      }, true)
    } else {
      switch (act) {
        case 'save':
          const isError = await props.onChangeAction(action, {
            matchesXs: matchesXs,
            matchesSm: matchesSm,
          }, true)
          !isError && setAction(matchesXs && 'list' || 'view')
          return
        case 'cancel':
          setAction(matchesXs && 'list' || 'view')
          props.onChangeAction(action, {
            matchesXs: matchesXs,
            matchesSm: matchesSm,
          }, false)
          return
      }
      setAction(act === 'duplicate' && 'add' || act)
      props.handleDisabled(false)
      if (act === 'add') {
        props.handleNew()
      } else if (act === 'delete') {
        setShowDeleteModal(true)
      }
    }
  }

  const [action, setAction] = useState(matchesXs && props.action === undefined && 'list' || props.action || 'view')
  const [actions, setActions] = useState(<EurestoAction isSubComponent={props.isSubComponent}
    action={action}
    btns={props.btns}
    onChange={handleAction}
    isAllow={props.isAllow || {
      add: true,
      update: true,
      delete: true,
      archive: true,
      unarchive: true
    }} />)

  useEffect(() => {
    setActions(<EurestoAction isSubComponent={props.isSubComponent}
      action={action}
      btns={props.btns}
      onChange={handleAction}
      isAllow={props.isAllow || {
        add: true,
        update: true,
        delete: true,
        archive: true,
        unarchive: true
      }} />)
  }, [props.btn, props.isAllow, action])
  const [title, setTitle] = useState(props.title || '')
  const matchesSm = useMediaQuery(theme => theme.breakpoints.down('sm'))
  const matchesXs = useMediaQuery(theme => theme.breakpoints.down('xs'))

  const [selectView, setSelectView] = useState(props.defaultTab ? props.defaultTab : 0)

  const [elemsLeft, setElemsLeft] = useState([actions])

  const [mainStyle, setMainStyle] = useState({})
  const [secondStyle, setSecondStyle] = useState({})

  const [children, setChildren] = useState(null)
  const [mainChildren, setMainChildren] = useState(null)

  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const [updateAction, setUpdateAction] = useState(false)

  useEffect(() => {
    setAction(action || 'view')
  }, [props.action, action])


  useEffect(() => {
    setElemsLeft([actions])
  }, [action, actions])

  useEffect(() => {
    setMainStyle({
      width: children && props.mainTabProps && props.mainTabProps.style && props.mainTabProps.style.width && `calc(${props.mainTabProps.style.width}px + 1px)` || '100%',
      maxWidth: children && props.mainTabProps && props.mainTabProps.style && props.mainTabProps.style.width && `calc(${props.mainTabProps.style.width}px + 1px)` || '100%',
      minWidth: children && !matchesSm && props.mainTabProps && props.mainTabProps.style && props.mainTabProps.style.width && `calc(${props.mainTabProps.style.width}px + 1px)` || '100%',
      borderRight: children && '1px solid ' + EurestoColor('EurestoPrimary')
    })
    children && setSecondStyle({
      width:
        matchesXs && '100%'
        || matchesSm && `calc(50% - 1px)`
        || mainChildren && props.mainTabProps && props.mainTabProps.style && props.mainTabProps.style.width && `calc(100% - ${props.mainTabProps.style.width}px - 1px)`
    })
    if (matchesXs && props.action === undefined && 'list') setAction('list')
  }, [matchesSm, matchesXs, children])

  const generateTitle = (ttl = '') => (action === 'view' || action === 'list') &&
    (
      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} alignItems={'center'}
        alignContent={'flex-start'} wrap={'nowrap'}>
        {
          matchesXs && action === 'view' &&
          <Grid item>
            <Grid container style={{ margin: 0, padding: 0 }} spacing={0} alignItems={'center'}
              alignContent={'center'} wrap={'nowrap'}>
              <i className={'ei-commun_chevron ei-left cursor pointer'} style={{ fontSize: 18, padding: 5 }} onClick={() => {
                setUpdateAction(false)
                setAction('list')
              }} />
            </Grid>
          </Grid>
        }
        <Grid item>
          <Grid container style={{ margin: 0, padding: 0 }} spacing={0} alignItems={'center'}
            alignContent={'center'} wrap={'nowrap'}>
            <i className={'ei-commun_visualiser'} style={{ fontSize: 18, padding: 5 }} />
          </Grid>
        </Grid>
        <Grid item xs style={{ margin: 0, padding: 0, maxWidth: `calc(100% - (28px${matchesXs && action === 'view' && ' * 2' || ''})))` }}>
          <Grid container style={{
            margin: 0, padding: 0,
          }} spacing={0} alignItems={'center'}
            alignContent={'center'} wrap={'nowrap'}>{ttl}
          </Grid>
        </Grid>
      </Grid>
    )
    || action === 'update' &&
    (
      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} alignItems={'center'}
        alignContent={'flex-start'} wrap={'nowrap'}>
        <Grid item>
          <Grid container style={{ margin: 0, padding: 0 }} spacing={0} alignItems={'center'}
            alignContent={'center'} wrap={'nowrap'}>
            <i className={'ei-commun_modifier'} style={{ fontSize: 18, padding: 5 }} />
          </Grid>
        </Grid>
        <Grid item xs style={{ margin: 0, padding: 0, maxWidth: 'calc(100% - 28px)' }}>
          <Grid container
            style={{
              margin: 0, padding: 0,
            }}
            spacing={0} alignItems={'center'}
            alignContent={'center'} wrap={'nowrap'}>{ttl}
          </Grid>
        </Grid>
      </Grid>
    )
    || action === 'add' &&
    (
      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} alignItems={'center'}
        alignContent={'flex-start'} wrap={'nowrap'}>
        <Grid item>
          <Grid container style={{ margin: 0, padding: 0 }} spacing={0} alignItems={'center'}
            alignContent={'center'} wrap={'nowrap'}>
            <i className={'ei-commun_ajouter'} style={{ fontSize: 18, padding: 5 }} />
          </Grid>
        </Grid>
        <Grid item xs style={{ margin: 0, padding: 0, maxWidth: 'calc(100% - 28px)' }}>
          <Grid container style={{
            margin: 0, padding: 0,
          }} spacing={0} alignItems={'center'}
            alignContent={'center'} wrap={'nowrap'}>{ttl}
          </Grid>
        </Grid>
      </Grid>
    )
    || ''

  const generateElemsLeft = elmsLeft => elmsLeft &&
    <Grid container spacing={0} justify={'space-between'} alignItems={'center'} alignContent={'center'} wrap={'nowrap'}>
      <Grid item xs>
        {elmsLeft}
      </Grid>
      <Grid item>{actions}
      </Grid>
    </Grid> || actions

  useEffect(() => {
    if (selectView === undefined) {
      setSelectView(0)
      return
    }
    const mTabs = (props.tabs || [])
      .filter(tab => matchesXs || tab.main)
      .map(tab => ({
        title: tab.title,
        form: tab.form,
        children: tab.children,
        update: tab.update,
        value: tab.value
      }))
    const sTabs = (props.tabs || [])
      .filter(tab => (!matchesXs && !tab.main))
      .map(tab => ({
        title: tab.title,
        children: tab.children,
        update: tab.update,
        value: tab.value
      }))

    let ttl
    let isForm
    let elmsLeft
    let sChildren
    let mChildren
    if (matchesXs) {
      if (mTabs && mTabs.length === 1) {
        ttl = mTabs[0].title || props.title
        isForm = mTabs[0].form
      } else if (mTabs && mTabs.length > 1) {
        elmsLeft = <Select value={selectView} fullWidth InputProps={{ style: { marginBottom: 0, marginLeft: -2 } }}
          default={selectView}
          options={mTabs.map(tab => ({
            value: tab.value,
            label: tab.title
          }))} onChange={(val) => onChangeView(val !== undefined ? val : selectView)} />
      }
      sChildren = props.tabs.find(tab => tab.value === selectView).children
    } else {
      ttl = mTabs && mTabs.length === 1 && mTabs[0].title || props.title || mTabs && mTabs.length > 1 && alert(`Il ne peut y avoir qu'une seule tab principale`)
      isForm = mTabs && mTabs.length === 1 && mTabs[0].title && mTabs[0].title.form
      const viewS = sTabs && sTabs.length > 0 ? (sTabs.find(tab => tab.value === selectView) ? selectView : sTabs[0].value) : undefined
      mChildren = mTabs && mTabs.length === 1 && mTabs[0].children
      sChildren = sTabs && sTabs.length > 0 && sTabs.find(tab => tab.value === viewS).children
      if (matchesSm) {
        elmsLeft = sTabs && sTabs.length > 0 &&
          <Select InputProps={{ style: { marginBottom: 0, marginLeft: -1 } }} default={viewS}
            value={viewS}
            options={sTabs.map(tab => ({
              value: tab.value,
              label: tab.title
            }))} onChange={(val) => setSelectView(val !== undefined ? val : viewS)} /> || null
      } else {
        elmsLeft = sTabs && sTabs.length > 0 &&
          <AppBar position='static' color='default'
            style={{ backgroundColor: 'transparent', boxShadow: 'none', marginLeft: -2 }}>
            <Tabs TabIndicatorProps={{ style: { backgroundColor: 'white' } }} value={viewS}
              onChange={(e, val) => setSelectView(val)} style={{ backgroundColor: 'transparent' }}
              variant="scrollable">
              {sTabs.map((tab, i) => <Tab key={'EurestoBlock-Tab-' + tab.value}
                disabled={props.disabled && viewS !== tab.value} value={tab.value} style={{
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                  zIndex: 1,
                  borderBottom: '.5px solid white',
                  backgroundColor: tab.backgroundColor,
                  color: tab.color
                }} label={tab.title} />
              )}
            </Tabs>
          </AppBar> || null
      }
    }
    setTitle(ttl && isForm && generateTitle(ttl) || ttl || '')
    setElemsLeft(elmsLeft && [generateElemsLeft(elmsLeft)] || [actions])
    setChildren(sChildren)
    setMainChildren(mChildren)
  }, [matchesSm, matchesXs, selectView, props.tabs, action, actions])

  return <EurestoDiv
    fullTitle={matchesXs}
    mainStyle={props.title === false && { padding: 0 } || {}}
    titleStyle={{
      padding: 0,
      textAlign: 'center',
      ...(!matchesXs && props.mainTabProps && props.mainTabProps.style || {})
    }} title={title} elemsLeft={elemsLeft}>
    <Grid container spacing={0} wrap={'nowrap'}>
      {
        mainChildren && <Grid item xs={matchesSm && 6} style={mainStyle}>{mainChildren({
          matchesXs: matchesXs,
          matchesSm: matchesSm,
          action: action
        })}</Grid>
      }
      {children && <Grid item xs={matchesXs && 12 || matchesSm && 6}
        style={secondStyle}>
        {children({
          matchesXs: matchesXs,
          matchesSm: matchesSm,
          action: action
        })}
      </Grid>
      }
    </Grid>

    <Modal open={showDeleteModal}
      onClose={() => setShowDeleteModal(false)}
      grid={{ xs: 5 }}>
      <EurestoDiv
        fullTitle={matchesXs}
        paddingTopBody={0}
        fromModal={true} style={{
          margin: 0,
          padding: 0,
          overflowY: 'auto'
        }} title={EurestoI18n.t('commun:Confirmation de suppression ')}
        buttonsLeft={[{
          icon: ' ei-commun_fermer',
          className: 'EurestoError--text EurestoText',
          cb: () => setShowDeleteModal(false)
        }]}
        buttonsRight={[{
          icon: ' ei-commun_valider',
          className: 'text-success',
          cb: () => {
            setShowDeleteModal(false)
            props.onChangeAction('delete', {
              matchesXs: matchesXs,
              matchesSm: matchesSm,
            }, true)
            setAction(matchesXs && 'list' || 'view')
          }
        }]}>
        <Grid container style={{ margin: 0, padding: 10 }} spacing={0} justify={'flex-start'} alignItems={'center'}>
          <Grid item style={{ margin: 0, padding: 0 }}>
            <span style={{
              wordWrap: 'break-word',
              width: '100%',
              whiteSpace: 'initial',
            }}>{EurestoI18n.t('commun:Êtes-vous sur de vouloir supprimer cet élément ? ') + `(${props.libelle})`}</span>
          </Grid>
        </Grid>
      </EurestoDiv>
    </Modal>
  </EurestoDiv>

})


// WEBPACK FOOTER //
// ./app/Components/EurestoBlock.js